import { render, staticRenderFns } from "./MarcaCombobox.vue?vue&type=template&id=5716b302&scoped=true&"
import script from "./MarcaCombobox.vue?vue&type=script&lang=js&"
export * from "./MarcaCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716b302",
  null
  
)

export default component.exports